class UserLocationService {
	async isLocationAllowed(): Promise<boolean> {
		try {
			await this.getCurrentLocation();
			return true;
		} catch (error) {
			return false;
		}
	}

	async getCurrentLocation(): Promise<GeolocationPosition> {
		return new Promise<GeolocationPosition>((resolve, reject) => {
			if (navigator.geolocation) {
				// https://stackoverflow.com/a/31916631
				// hacky fix - call getCurrentPosition to avoid flaky bug - first call not always works..
				navigator.geolocation.getCurrentPosition(
					function () {},
					function () {},
					{}
				);
				navigator.geolocation.getCurrentPosition(
					position => {
						resolve(position);
					},
					() => reject('Failed to get geolocation')
				);
			} else {
				reject('GeoLocation not supported/not allowed.');
			}
		});
	}
}

export default UserLocationService;
